import React, { ReactNode } from "react";
import { Navigate, Outlet } from "react-router";
import { useEUMSMultiEndPointPermission } from "../hooks/useEUMSMultiEndPointPermission";
import { ROUTES } from "./RouteConstant";

interface PermissionProtectedRouteProps {
  children: ReactNode;
  endpointCodes: string[];
}

const PermissionProtectedRoute: React.FC<PermissionProtectedRouteProps> = ({
  children,
  endpointCodes,
}) => {
  const hasPermission = useEUMSMultiEndPointPermission(endpointCodes);

  if (!hasPermission) {
    return <Navigate to={ROUTES.DASHBOARD} replace />; // Redirect to dashboard if no permission
  }

  return children ? <>{children}</> : <Outlet />;
};

export default PermissionProtectedRoute;
